/**
 * 공지 팝업을 「안 보겠다」 고 누른 기록.
 *
 * <h2>왜 브라우저에 두는가 (사용자 결정 2026-09-10)</h2>
 * 서버에 남기려면 <b>사람마다 본 표</b>가 필요한데, 창 하나 때문에 표를 만들 일은 아니다 —
 * 기기를 옮기면 한 번 더 뜨는 편이 낫다(`AssociationChangeBanner` 와 같은 판단).
 *
 * <h2>왜 따로 떼어 놓았나</h2>
 * 이 기록을 읽고 쓰는 곳이 <b>둘</b>이다 — 홈(`NoticePopup`, 무엇을 띄울지 고른다)과
 * 새 창(`NoticePopupWindow`, 버튼이 거기 있다). 둘은 <b>서로 다른 창</b>이지만 주소가 같으므로
 * `localStorage` 를 함께 쓴다: 새 창에서 「더이상 보지 않기」 를 누르면 그 기록이 홈에도 보인다.
 */

/** 닫은 것을 적어 두는 자리. `{ 글 id: 'forever' | 'YYYY-M-D' }`. */
const STORE_KEY = 'notice-popup-dismissed';

/** 「더이상 보지 않기」. 날짜 자리에 이 말이 있으면 어느 날에도 서지 않는다. */
export const FOREVER = 'forever';

/** 오늘 날짜 — <b>보는 사람의 시간대</b>로 센다. 「오늘」 은 서버의 오늘이 아니라 그 사람의 오늘이다. */
export function todayKey(): string {
  const now = new Date();
  return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
}

function readDismissals(): Record<string, string> {
  try {
    const raw = window.localStorage.getItem(STORE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    // 남이 넣어 둔 값이거나 옛 모양일 수 있다. 모양이 아니면 <b>없는 것으로</b> 본다 —
    // 여기서 터지면 홈이 통째로 하얗게 된다.
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    // 사생활 보호 모드에서는 접근이 막힌다. 기억을 못 할 뿐이라 창은 그대로 뜬다.
    return {};
  }
}

function writeDismissals(next: Record<string, string>) {
  try {
    window.localStorage.setItem(STORE_KEY, JSON.stringify(next));
  } catch {
    // 못 적으면 다음에 한 번 더 뜬다. 그것 때문에 누름이 실패한 것처럼 굴지는 않는다.
  }
}

export function isDismissed(postId: string): boolean {
  const until = readDismissals()[postId];
  return until === FOREVER || until === todayKey();
}

export function rememberDismissal(postId: string, until: string) {
  writeDismissals({ ...readDismissals(), [postId]: until });
}

/** 아직 서 있는 팝업의 것만 남긴다. 기간이 끝난 글의 기억은 쓸 데가 없다. */
export function pruneDismissals(liveIds: string[]) {
  const stored = readDismissals();
  const kept = Object.fromEntries(Object.entries(stored).filter(([id]) => liveIds.includes(id)));
  if (Object.keys(kept).length !== Object.keys(stored).length) writeDismissals(kept);
}
